import React from 'react';
import { FieldTextInput } from '../../../../components';

const FilterKeyword = props => <FieldTextInput className={props.className}>KeywordFilter</FieldTextInput>;
export default FilterKeyword;
